var _rect, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdentityCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#FEF1F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.3346 41.6667C53.3346 50 47.5013 54.1667 40.568 56.5833C40.2049 56.7064 39.8105 56.7005 39.4513 56.5667C32.5013 54.1667 26.668 50 26.668 41.6667V30C26.668 29.558 26.8436 29.134 27.1561 28.8215C27.4687 28.5089 27.8926 28.3333 28.3346 28.3333C31.668 28.3333 35.8346 26.3333 38.7346 23.8C39.0877 23.4983 39.5369 23.3326 40.0013 23.3326C40.4657 23.3326 40.9149 23.4983 41.268 23.8C44.1846 26.35 48.3346 28.3333 51.668 28.3333C52.11 28.3333 52.5339 28.5089 52.8465 28.8215C53.159 29.134 53.3346 29.558 53.3346 30V41.6667Z",
    stroke: "url(#paint0_linear_1375_2659)",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 40L38.3333 43.3333L45 36.6667",
    stroke: "url(#paint1_linear_1375_2659)",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1375_2659",
    x1: 26.668,
    y1: 40.002,
    x2: 53.3346,
    y2: 40.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1375_2659",
    x1: 35,
    y1: 40,
    x2: 45,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentityCheck);
export default __webpack_public_path__ + "static/media/Identity Check.d96628fc47782c2568fe4e9d2b23a0ae.svg";
export { ForwardRef as ReactComponent };